import SeoArticleLayout from '@/components/feature/SeoArticleLayout';
import { seoArticles } from '@/mocks/seo-articles';

export default function StreetwearPage() {
  return <SeoArticleLayout article={seoArticles[2]} />;
}